import * as util from 'lib/util.js'
import { Router } from '@vaadin/router/dist/vaadin-router.js';
import { LitElement,  TemplateResult, property, customElement, css } from 'lit-element';
import {html, render} from 'lit-html';
import {storeInstance} from "store/index.js";
import "@ui5/webcomponents/dist/Table.js";
import "@ui5/webcomponents/dist/TableRow.js";
import "@ui5/webcomponents/dist/TableCell.js";
import "@ui5/webcomponents/dist/TableColumn.js";

import "./kb-folders.js";

class KbFolderviewFiles extends (LitElement)   {
    constructor(){
        super();
        this.tabnum=0;
       }    

    connectedCallback(){
        this.subscription = storeInstance.subscribe(state => {
            this.stateChange(state);
        });
        this.state = storeInstance.state
        this.string = this.state.strings;
        
        this.addEventListener('fileClicked', this._handleFileClicked.bind(this));
        if(this.folderId){
            this.refresh();
        }
    }

    refresh(){
        storeInstance.dispatch("getFilesInFolder", this.folderId )
    }

    disconnectedCallback() {
        storeInstance.unsubscribe(this.subscription)
    }

    _setSelected(node, selectedId){
        if(node.id==selectedId){
            node.selected=true;
        } else {
            node.selected=false;
        }
        if(node.children){
            for(var i=0;i<node.children.length;i++){
                this._setSelected(node.children[i], selectedId)
            }
        }
    }

    stateChange(state){
        this.state = state;
        this.string = this.state.strings;
        if(this.folderId!=this.lastFolderId){
            this.lastFolderId = this.folderId;
            this.refresh();
        }

        if(this.state.folder_files){
            this.myRender();
        } else {
            render(this.nofilesTemplate(), this.shadowRoot);
        }
    }

    myRender(){
        render(this.folderFilesTemplate(), this.shadowRoot);
    }

    isSelected(row){
        var retval = '';
        if(this.selectedFileId){
            if(row.resInfo.lblSeqId==this.selectedFileId){
                retval = ' rowselected '
            }
        } 
        return retval;
    }

    
    nofilesTemplate(){
        return html`<style>
             
             </style>`
    }
    
    folderFilesTemplate(){
       return html`
            <style>
            .rowselected{
                margin:-8px -4px -8px -4px;
                padding:8px 4px 8px 4px;
                box-sizing: border-box;
                background-color:  rgb(229, 240, 250);
            }
            .datarow{
                cursor: pointer;
            }
            ui5-icon{
                margin-left:2em;
            }
            </style>
            
            <ui5-table id="files" id="filestable">

            ${this.state.folder_files.columnMeta.map((col) => 
                html`
                <ui5-table-column class='foo' slot="columns">
                    ${col.colName} 
                </ui5-table-column>`
            )}
                <ui5-table-column class='foo' slot="columns">
                    ${this.string["_action"]}
                </ui5-table-column>
            ${this.state.folder_files.resultRow.map((row) => this._rowsTemplate(row))}
        
            </ui5-table>
            
            `
        }

        

    _rowsTemplate(row){
        return html`
        
                <ui5-table-row class="datarow has-menu" .item="${row}" @click="${this._handleFileClicked.bind(this)}" @dblclick="${this._loadFile.bind(this)}">
                    ${row.columnValues.map((cell) => html`<ui5-table-cell  align='left'>
                        <div class="${this.isSelected(row)}">
                            &nbsp;${cell.value}
                        </div>
                        </ui5-table-cell>`)}
                        <ui5-table-cell  align='left'>
                        <div class="${this.isSelected(row)}">
                            <ui5-icon @click="${this._download.bind(this, row)}" name="download-from-cloud" title="${this.string["_download"]}"></ui5-icon>
                            <ui5-icon @click="${this._newTab.bind(this, row)}"  name="internet-browser" title="${this.string["_newtab"]}"></ui5-icon>
                        </div>
                        </ui5-table-cell>
                </ui5-table-row>
        
                `
            }

    
    _handleFileClicked(e){
        if(this.selectedFileId!=e.currentTarget.item.resInfo.lblSeqId){
            this.selectedFileId = e.currentTarget.item.resInfo.lblSeqId;
            this.myRender();
        }
        // storeInstance.dispatch("setState", {property: "selected_folderview_file", value:   e.currentTarget.item.resInfo  } )

    }
    _newTab(item,e){
        this.tabnum++
        window.open('/kb/jrest/getResource?lblSeqId='+ item.resInfo.lblSeqId,'_newtab'+ this.tabnum);
        }

    _download(item,e){
        var link = document.createElement("a");
        link.setAttribute('download', item.resInfo.name);
        link.href ='/kb/jrest/getResource?lblSeqId='+ item.resInfo.lblSeqId ;
        document.body.appendChild(link);
        link.click();
        link.remove();
    }

    _loadFile(e){
        Router.go("/kb/" + this.state.langCode  + "/"  + this.state.item.item.externalId   + "/folder/" + this.folderId + "/" + e.currentTarget.item.resInfo.lblSeqId );
    }
    _contextmenuclicked(e){
        console.log(e.currentTarget.id)
    }

}



customElements.define('kb-folderview-files', KbFolderviewFiles)
